/* Koforto 落地页通用交互：CTA 滚动、倒计时、库存条、数据圆环、图库、轮播、悬浮按钮。购买逻辑在 kf-bundle.js。 */
(function () {
  // 同一页面可放多个落地页分区（拆成几段，中间插入其它分区），每个都初始化
  const init = (root) => {
  if (!root || root._kf) return;
  root._kf = true;
  const ds = root.dataset;

  /* CTA：平滑滚动到页内锚点（#offer / #buy） */
  root.querySelectorAll('[data-cta]').forEach((a) =>
    a.addEventListener('click', (e) => {
      if (e.target.closest('[data-float-close]')) return;
      const id = (a.getAttribute('href') || '').replace(/^.*#/, '');
      const t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })
  );

  /* 倒计时：只读真实截止时间，未配置或到期即隐藏 */
  root.querySelectorAll('[data-countdown]').forEach((el) => {
    const end = ds.saleEnds ? new Date(ds.saleEnds).getTime() : NaN;
    if (isNaN(end)) { el.hidden = true; return; }
    const pad = (n) => String(n).padStart(2, '0');
    const sep = el.textContent.includes(' : ') ? ' : ' : ':';
    (function tick() {
      const d = end - Date.now();
      if (d <= 0) { el.hidden = true; return; }
      el.hidden = false;
      el.textContent = [Math.floor(d / 3.6e6), Math.floor((d % 3.6e6) / 6e4), Math.floor((d % 6e4) / 1e3)].map(pad).join(sep);
      setTimeout(tick, 1000);
    })();
  });

  /* 库存条：未配置真实库存则隐藏 */
  const left = parseInt(ds.stockLeft, 10), total = parseInt(ds.stockTotal, 10);
  root.querySelectorAll('[data-stock]').forEach((box) => {
    if (isNaN(left) || isNaN(total) || !total) { box.hidden = true; return; }
    const bar = box.querySelector('[data-stock-bar]');
    const txt = box.querySelector('[data-stock-text]');
    if (bar) bar.style.width = Math.max(4, Math.min(100, (left / total) * 100)) + '%';
    if (txt) txt.textContent = `${left} ${ds.stockUnit || 'units'} remaining`;
  });

  /* 数据圆环 */
  root.querySelectorAll('[data-ring]').forEach((r) => {
    if (r.querySelector('svg')) return;
    const p = +r.dataset.ring, C = 2 * Math.PI * 44;
    r.insertAdjacentHTML('afterbegin', `<svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="44" fill="none" stroke="#EEE" stroke-width="7"/><circle cx="50" cy="50" r="44" fill="none" stroke="var(--accent, #E07A5F)" stroke-width="7" stroke-linecap="round" stroke-dasharray="${(C * p) / 100} ${C}"/></svg>`);
  });

  /* 图库：缩略图切换；选颜色时切到该变体图片 */
  function setMain(g, src) {
    const img = g.querySelector('[data-gallery-main] img');
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.src = src;
  }
  root.querySelectorAll('[data-gallery]').forEach((g) => {
    g.querySelectorAll('.thumbs button').forEach((b) =>
      b.addEventListener('click', () => {
        g.querySelectorAll('.thumbs button').forEach((x) => x.removeAttribute('aria-current'));
        b.setAttribute('aria-current', 'true');
        setMain(g, b.dataset.src);
      })
    );
  });
  root.addEventListener('kf:change', (e) => {
    const v = e.detail && e.detail.variants && e.detail.variants[e.detail.variants.length - 1];
    if (!v || !v.image) return;
    const g = e.target.closest('section, .buy, .order, .offer') && e.target.closest('section, .buy, .order, .offer').querySelector('[data-gallery]');
    if (g) setMain(g, v.image);
  });

  /* 横向轮播（视频 / UGC） */
  root.querySelectorAll('[data-track]').forEach((t) => {
    const wrap = t.parentElement;
    const prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => t.scrollBy({ left: -t.clientWidth, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => t.scrollBy({ left: t.clientWidth, behavior: 'smooth' }));
    const dots = [...wrap.querySelectorAll('[data-dots] i, .dots i')];
    if (dots.length)
      t.addEventListener('scroll', () => {
        const max = t.scrollWidth - t.clientWidth || 1;
        const i = Math.round((t.scrollLeft / max) * (dots.length - 1));
        dots.forEach((d, k) => d.classList.toggle('on', k === i));
      }, { passive: true });
  });

  /* 桌面悬浮优惠条关闭 */
  root.querySelectorAll('[data-float-close]').forEach((b) =>
    b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); b.parentElement.remove(); })
  );

  /* 手机底部悬浮按钮：滚过首屏后出现，到购买区时隐藏 */
  const bar = root.querySelector('[data-sticky]');
  const after = ds.stickyAfter && root.querySelector(ds.stickyAfter);
  const hides = ds.stickyHide ? document.querySelectorAll(ds.stickyHide) : [];
  if (bar && after && 'IntersectionObserver' in window) {
    let past = false; const vis = new Set();
    const upd = () => bar.classList.toggle('show', past && vis.size === 0);
    new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(after);
    const io = new IntersectionObserver((es) => { es.forEach((e) => (e.isIntersecting ? vis.add(e.target) : vis.delete(e.target))); upd(); });
    hides.forEach((h) => io.observe(h));
  }

  root.querySelectorAll('[data-year]').forEach((e) => (e.textContent = new Date().getFullYear()));
  root.querySelectorAll('[data-month]').forEach((e) => (e.textContent = new Date().toLocaleDateString(document.documentElement.lang || 'en-GB', { month: 'long', year: 'numeric' })));
  };
  const run = () => document.querySelectorAll('[data-kf-landing]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
